import React, {useCallback, useRef, useState, useEffect} from 'react';
import { AutoComplete } from 'primereact/autocomplete'

import { FormPageFieldComponentProps } from 'types/formPage';
import { withFormikFormControl } from '../FormikFormControl';
import {fieldQuery} from "../../helpers/query";
import {useField, useFormikContext} from "formik";
import _ from 'lodash';
import DisplayRendering from "../DisplayRendering";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import RecordSearch from "../RecordSearch";
import {Dropdown} from "primereact/dropdown";
import {extract} from "../utils";
import searchElements from "../AirtableFields/RecordLinks/search.common";

export type AdvancedReferenceProps = FormPageFieldComponentProps;

const AdvancedReference = (props: AdvancedReferenceProps) => {
  const { name, details, extraConfig, ...rest } = props;
  const { display_as = 'lookup'} = extraConfig
    //display modes: dropdown (ie - autocomplete), lookup
  const [records, setRecords] = useState(null)
  const [filteredRecords, setFilteredRecords] = useState( [] )
  const [showSearch, setShowSearch] = useState(false)
  const [isInQuery, setInQuery] = useState(false)
  const {
        values,
        setFieldValue,
  } = useFormikContext();
  const [field, meta, helpers] = useField(props);
  const openEvent = useRef(null)
  const removeSelected = ['dropdown'].includes(display_as)
  const optionTemplate = (option) => {

    return <div>{`${option?.title || option?.name || ''}`}</div>;
  };
  const { onQuery } = searchElements(details.path, props, {values,field,setRecords,setFilteredRecords,setInQuery, records, filteredRecords, isInQuery}, removeSelected)

  const itemTemplate = (option) => {
        if (!option) {
            return <p />;
        }
        return <div>{`${option[extraConfig.field || 'Name'] || ''}`}</div>;
    };

  if(display_as === 'dropdown') {
      return (
          <AutoComplete
              field={"Name"}
              name={name}
              suggestions={records}
              completeMethod={onQuery}
              itemTemplate={itemTemplate}
              {...extract( {
                  dropdown: true,
                  forceSelection: undefined,
                  type: undefined, field: "Name",
                  autoHighlight: undefined, scrollHeight: undefined,
                  dropdownMode: 'current', dropdownAutoFocus: undefined,
                  minLength: undefined, delay: undefined, style: undefined,className: undefined,
                  inputStyle: undefined,inputClassName: undefined,panelClassName: undefined,panelStyle: undefined,
                  placeholder: undefined,readOnly: undefined,maxLength: undefined,size: undefined,
                  dropdownIcon: undefined,removeIcon: undefined,
              }, extraConfig, rest)}
              onBlur={ (e) => {
                  if(rest.value && !_.isObject(rest.value)){
                      helpers.setValue(null)
                  }
              }}
          />
      );
  }else if(display_as === 'lookup') {
      const hasValue = !_.isEmpty(rest.value)
      console.log('Lookup Render', hasValue, rest.value)
      const {displayRecord = true} = extraConfig
      return (
          <>
              {displayRecord && hasValue && <DisplayRendering name={name} {...{extraConfig: {state: {showCheck: false, highlight: false, selected: true, showClear: true, onClear: () => helpers.setValue(null)}, render_as: 'record', ..._.get(extraConfig, 'display', {})}, ...rest}}/>}
              <Button icon={'pi pi-search'} label={hasValue ? 'Modify' : 'Search'} onClick={(e) => {
                  setShowSearch(true)
                  e.preventDefault()
                  openEvent.current = e
              }}/>
              <RecordSearch visible={showSearch} isInQuery={isInQuery} onQuery={onQuery} onHide={() => setShowSearch(false)}
                 field={field} details={{...details, ...(_.get(extraConfig,'search') || {})}}
                 multiple={false}
                 allowClickDone={true}
                 allowEmptySelection={true}
                 initSelected={rest.value}
                 records={filteredRecords}
                 openEvent={openEvent.current}
                 onDone={ record => {
                     setShowSearch(false)
                     helpers.setValue( record )
                 }}
              />

          </>
      )
  }
};

const AdvancedReferenceFormik = withFormikFormControl()(AdvancedReference);

export default AdvancedReferenceFormik;
